module.exports = __webpack_public_path__ + "static/media/seven-tokens.d7817d9b.svg";